import { tw } from '@/utils/tw';
import BaseArticleFooterTheme from 'base/components/ArticleFooter/theme';

const DisclaimerLink = tw.theme({
  extend: BaseArticleFooterTheme.DisclaimerLink,
});

const Tag = tw.theme({
  extend: BaseArticleFooterTheme.Tag,
});

const ArticleFooter = tw.theme({
  extend: BaseArticleFooterTheme,
});

export default Object.assign(ArticleFooter, { Tag, DisclaimerLink });
